<template>
    <div class="view2Wrapper shadowRadius cardPadding cardWidth">
            <div class="tipsGlobalText" v-html="tips">{{tips}}</div>
        <div class="v2Items">
            <div class="dataCls">
                <Info name="累计确诊" :today="list.data.confirmed" :increase="list.data.confirmedRelative" color="default"/>
                <Info name="疑似" :today="list.data.unconfirmed" :increase="list.data.unconfirmedRelative"  color="blue"
                      v-if="list.data.unconfirmed&&list.data.unconfirmedRelative"/>
                <Info name="死亡" :today="list.data.died" :increase="list.data.diedRelative" color="black"/>
                <Info name="治愈" :today="list.data.crued" :increase="list.data.cruedRelative" color="green"/>
            </div>

        </div>
    </div>
</template>
<script>
    import Info from "../Use/Info";

    export default {
        name: "View0",
        components: {
            Info
        },
        props: {
            list: {
                type: Object,
                default: []
            },
            tips:{
                type: String,
                default: ''
            },
        },
        data() {
            return {};

        },
        methods: {
            onRouter(type, path) {
                if (type == 0) {
                    this.$router.push({
                        path
                    });
                } else {
                    window.location.href = path;
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    .view2Wrapper {

        .dataCls{
            display: flex;
            /*flex-wrap: wrap;*/
            justify-content: space-between;
            align-items: center;

        }
        .v2Items{

        }

    }

</style>
